// fields/renderDateField.tsx
import { Grid, TextField } from "@mui/material";
import React from "react";
import { ToolbarFieldConfig, TFilterFieldsLocal } from "../ToolbarSinisterGeneric";

type Props = {
	field: ToolbarFieldConfig;
	filters: TFilterFieldsLocal;
	setFilter: (key: string, value: any) => void;
};

export function renderDateField({ field, filters, setFilter }: Props) {
	const value = filters[field.key] ?? "";

	return (
		<Grid item key={field.key}>
			<TextField
				label={field.label}
				type="date"
				size="small"
				value={value}
				onChange={(e) => {
					setFilter(field.key, e.target.value);
					field.onChange?.(e.target.value, filters, setFilter);
				}}
				InputLabelProps={{ shrink: true }}
				{...field.extraProps}
			/>
		</Grid>
	);
}
